import { BaseEntity } from 'entities';
import { ReservationTimeConstraint, ReservationTimeConstraintForm } from 'entities/reservation_time_constraint';

export type DayOfTheWeek = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';
export const DayOfTheWeeks: { [key in DayOfTheWeek]: string } = {
  mon: '月',
  tue: '火',
  wed: '水',
  thu: '木',
  fri: '金',
  sat: '土',
  sun: '日',
};
export type ReservationConstraint = BaseEntity & {
  dayOfTheWeeks?: DayOfTheWeek[];
  reservableHoliday?: boolean;
  reservationTimeConstraints?: ReservationTimeConstraint[];
  unavailable?: boolean;
};

export type ReservationConstraintForm = ReservationConstraint & {
  reservationTimeConstraintsAttributes?: ReservationTimeConstraintForm[];
  dayOfTheWeeksObject?: { [key: number]: DayOfTheWeek };
  _destroy?: boolean;
};

// TODO: 編集フォームを実装する際は entities/instrument.ts のコメントと実装を参考に、同様の構造で実装する
